import * as types from "../../constants/actionTypes";

export const setLoader = (data) => {
  return {
    type: types.MODULE_RESERVASI_SET_LOADER,
    payload: data,
  };
};

export const initCariPasien = () => {
  return {
    type: types.MODULE_RESERVASI_INIT_FORM_CARI_PASIEN,
  };
};

export const initFormPasien = () => {
  return {
    type: types.MODULE_RESERVASI_INIT_FORM_RESERVASI,
  };
};

export const validatePasienCode = (history, value) => {
  return {
    type: types.MODULE_RESERVASI_VALIDATE_CODE,
    history,
    value,
  };
};

export const handleStateCariPasien = (property, value) => {
  return {
    type: types.MODULE_RESERVASI_HANDLE_STATE_CARI_PASIEN,
    property,
    value,
  };
};

export const handleStateReservasi = (property, value) => {
  return {
    type: types.MODULE_RESERVASI_HANDLE_STATE_RESERVASI,
    property,
    value,
  };
};

export const resetPoli = () => {
  return {
    type: types.MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI_RESET,
  };
};

export const validateDokterPoliBy = (property, value) => {
  return {
    type: types.MODULE_RESERVASI_VALIDATE_DOKTER_DAN_POLI,
    property,
    value,
  };
};

export const getMasterData = () => {
  return {
    type: types.MODULE_RESERVASI_MASTER_DATA,
  };
};

export const postFormReservasi = (history, value) => {
  return {
    type: types.MODULE_RESERVASI_SUBMIT_FORM_RESERVASI,
    history,
    value,
  };
};
